import { Injectable } from '@angular/core'
import { ObjectId } from 'bson'
import { firstValueFrom } from 'rxjs'

import { TrackedBarcodesService } from './tracked-barcodes.service'
import {
  TrackedBarcodeMode,
  TrackedBarcodeOperation,
  TrackedBarcodePhase,
} from './models/tracked-barcode.types'

export interface TrackBarcodeParams {
  operation: TrackedBarcodeOperation
  product_id?: string
  barcode?: string
  qty: number
  location_id: string
  created_by: string
  tenant_id: string
  warehouse_id: string
  mode?: TrackedBarcodeMode
  phase?: TrackedBarcodePhase
  packing_list_id?: string
  order_ids?: string[]
  lot?: string
  serial?: string
  expiration_date?: string
}

@Injectable({ providedIn: 'root' })
export class TrackedBarcodesRepository {
  constructor(private readonly service: TrackedBarcodesService) {}

  async trackBarcode(params: TrackBarcodeParams): Promise<boolean> {
    if (
      !this.isRealId(params.created_by) ||
      !this.isRealId(params.tenant_id) ||
      !this.isRealId(params.warehouse_id) ||
      !this.isRealId(params.location_id) ||
      (params.product_id !== undefined && !this.isRealId(params.product_id)) ||
      (params.operation === 'PACKING_LIST' && !params.order_ids?.length)
    ) {
      return false
    }
    try {
      await firstValueFrom(
        this.service.create$({
          ...params,
          _id: new ObjectId().toHexString(),
          created_at: new Date().toISOString(),
          barcode:
            params.mode === 'ITEM_SELECTION' ? undefined : params.barcode,
        }),
      )
      return true
    } catch (err) {
      return false
    }
  }

  private isRealId(value?: string): value is string {
    return !!value && value !== '-'
  }
}
